export function ifExistsReturn(check) {
  if (typeof check !== 'undefined') {
    return check
  }
  return false
}
